import ProductionTagSelect, { MODES } from 'components/ProductionTagSelect';
import { components as SelectComponents } from 'react-select';
import { type FilterRender } from 'react-table-v6';
import { type OptionProps } from 'react-select/lib/components/Option';
import { type ComponentType } from 'react';
import { type ControlProps } from 'react-select/lib/components/Control';

type ValueType = { value: string; label: string }[];
const Option: ComponentType<OptionProps<ValueType>> = props => (
  <div>
    <SelectComponents.Option {...props}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {!props.isDisabled && (
          <input
            style={{
              width: '20px',
              marginRight: '10px',
            }}
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />
        )}
        <label style={{ width: '100%', textWrap: 'wrap' }}>{props.label}</label>
      </div>
    </SelectComponents.Option>
  </div>
);

const Control: ComponentType<ControlProps<ValueType>> = props => {
  const { innerProps } = props;
  const hasSelectedValues =
    Array.isArray(props.getValue?.()) && (props.getValue()?.length ?? 0) > 0;
  const style = {
    marginBottom: '2px',
    ...(hasSelectedValues ? {} : { height: '20px' }),
  };

  return (
    <SelectComponents.Control
      {...props}
      innerProps={{
        ...innerProps,
        // @ts-expect-error styles works
        style,
      }}
    />
  );
};

const ProductionTagsFilter: FilterRender = ({ filter, onChange }) => {
  const filterValue = filter?.value;
  const filterMode = filterValue?.mode;

  const isTagSelectMode = (mode: string) =>
    mode === MODES.and || mode === MODES.or;

  const selectedMode = isTagSelectMode(filterMode) ? filterMode : MODES.or;
  const selectedTags = Array.isArray(filterValue?.tags) ? filterValue.tags : [];

  return (
    <ProductionTagSelect
      selectedTags={selectedTags}
      selectedMode={selectedMode}
      menuWidth={300}
      onChange={(newMode, newSelectedTags) =>
        onChange({
          mode: newMode,
          tags: newSelectedTags,
        })
      }
      customComponents={{ Option, Control }}
    />
  );
};

export default ProductionTagsFilter;
